import React, { useState, useCallback } from 'react'
import { Button, Modal, ModalHeader, ModalBody, Alert } from 'reactstrap';
import Cropper from 'react-easy-crop'
import axios from 'axios'

import { tokenConfig } from '../../utils/apiConfig'

const getCroppedBlob = (imageSrc, pixelCrop) =>
    new Promise((resolve, reject) => {
        const image = new Image()
        image.onload = () => {
            const canvas = document.createElement('canvas')
            canvas.width = pixelCrop.width
            canvas.height = pixelCrop.height
            const ctx = canvas.getContext('2d')
            ctx.drawImage(
                image,
                pixelCrop.x, pixelCrop.y,
                pixelCrop.width, pixelCrop.height,
                0, 0,
                pixelCrop.width, pixelCrop.height
            )
            canvas.toBlob(blob => {
                if (!blob) return reject(new Error('Canvas is empty'))
                resolve(blob)
            }, 'image/jpeg', 0.92)
        }
        image.onerror = reject
        image.src = imageSrc
    })

const UpdatePhoto = props => {
    const [errorMessage, setErrorMessage] = useState('')
    const [imageSrc, setImageSrc] = useState(null)
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [loading, setLoading] = useState(false)

    const onCropComplete = useCallback((_, pixels) => {
        setCroppedAreaPixels(pixels)
    }, [])

    const handleFileChange = (e) => {
        const file = e.target.files[0]
        if (!file) return
        if (file.size > 10 * 1024 * 1024 || !file.type.startsWith('image/')) {
            setErrorMessage('Requires an image file below 10 MB')
            return
        }
        setErrorMessage('')
        const reader = new FileReader()
        reader.onload = () => setImageSrc(reader.result)
        reader.readAsDataURL(file)
    }

    const handleClose = () => {
        setImageSrc(null)
        setCrop({ x: 0, y: 0 })
        setZoom(1)
        setCroppedAreaPixels(null)
        setErrorMessage('')
        props.toggle()
    }

    const submitProfile = async (e) => {
        e.preventDefault()
        setErrorMessage('')
        setLoading(true)
        try {
            const blob = await getCroppedBlob(imageSrc, croppedAreaPixels)
            const formData = new FormData()
            formData.append('photo', blob, 'photo.jpg')
            const uploadRes = await axios.post('/api/upload', formData, tokenConfig())
            const { key, url } = uploadRes.data
            await axios.patch('/api/auth', { _id: props._id, photo: key }, tokenConfig())
            props.updateProfilePhoto(url)
            setLoading(false)
            handleClose()
        } catch (err) {
            setLoading(false)
            setErrorMessage(err.response?.data?.message || 'Upload failed')
        }
    }

    return (
        <div>
            <Modal isOpen={props.modal} toggle={handleClose} size='lg'>
                <ModalHeader toggle={handleClose}>Profile Photo</ModalHeader>
                <ModalBody>
                    {errorMessage && <Alert color='danger'>{errorMessage}</Alert>}

                    {!imageSrc ? (
                        <input
                            type='file'
                            accept='image/*'
                            onChange={handleFileChange}
                        />
                    ) : (
                        <>
                            <div style={{ position: 'relative', width: '100%', height: 320, background: '#333' }}>
                                <Cropper
                                    image={imageSrc}
                                    crop={crop}
                                    zoom={zoom}
                                    aspect={1}
                                    onCropChange={setCrop}
                                    onZoomChange={setZoom}
                                    onCropComplete={onCropComplete}
                                />
                            </div>
                            <div style={{ marginTop: '1rem' }}>
                                <label style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.85rem' }}>Zoom</label>
                                <input
                                    type='range'
                                    min={1}
                                    max={3}
                                    step={0.05}
                                    value={zoom}
                                    onChange={e => setZoom(Number(e.target.value))}
                                    style={{ width: '100%' }}
                                />
                            </div>
                            <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
                                <Button
                                    color='secondary'
                                    onClick={() => { setImageSrc(null); setZoom(1); setCrop({ x: 0, y: 0 }) }}
                                    style={{ flex: 1 }}
                                >
                                    Choose Different Photo
                                </Button>
                                <Button
                                    color='dark'
                                    style={{ flex: 1, cursor: loading && 'progress' }}
                                    disabled={loading}
                                    onClick={submitProfile}
                                >
                                    {loading ? 'Uploading…' : 'Upload Photo'}
                                </Button>
                            </div>
                        </>
                    )}
                </ModalBody>
            </Modal>
        </div>
    )
}

export default UpdatePhoto
